import merge from 'lodash/merge';
import { healthConfig } from '../../constants';
export var getHealthProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(healthConfig === null || healthConfig === void 0 ? void 0 : healthConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.health) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};